module.exports = __webpack_public_path__ + "static/media/TOI.3dff013b.jpg";